var ItemCountOperation;
(function(ItemCountOperation) {
    ItemCountOperation["INCREASE"] = 'increase';
    ItemCountOperation["DECREASE"] = 'decrease';
})(ItemCountOperation || (ItemCountOperation = {}));

export { ItemCountOperation };
//# sourceMappingURL=types.js.map
